export default __webpack_public_path__ + "static/media/gallery_01.94787ca1.jpg";